export const defaultFilters = { page: 1, pageSize: 20 };

export const SCROLL = {
  y: 550,
  x: 1000,
}

export const getFilters = (filters = '') => {
  try {
    const objFilters = JSON.parse(filters);
    return objFilters;
  } catch (err) {
    return defaultFilters;
  }
}
